// extracted by mini-css-extract-plugin
export default {"overlay":"ChunkListOverlay_overlay__uen9w","loadingText":"ChunkListOverlay_loadingText__druqV"};